import { FC, FormEvent } from 'react'

interface IProps {
  defaultCode: string
  locationName: string
  onSearch: (code: string) => void
}

const SearchForm: FC<IProps> = ({ defaultCode, locationName, onSearch }) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const code = formData.get('code') as string
    const formattedCode = code.replace(/[^0-9]/gi, '')
    onSearch(formattedCode)
  }

  return (
    <form onSubmit={handleSubmit}>
      <table className='selectie'>
        <thead>
          <tr>
            <th className='selectie-label'>Tijdvakcode:</th>
            <th className='selectie-label'>Vestiging:</th>
            <th className='selectie-label'></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type='text'
                name='code'
                id='code'
                defaultValue={defaultCode}
              />
            </td>
            <td>{locationName}</td>
            <td>
              <button className='btn btn-primary' type='submit'>
                Zoek tijdvakken
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  )
}

export default SearchForm
